import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { allowListMessages } from 'src/features/allowList/utils/allowListMessages';
import { AllowListItem } from 'src/features/allowList/utils/types';
import DeleteAllowListItemFormModal from 'src/features/allowListItem/components/forms/DeleteAllowListItemFormModal';
import UpdateAllowListItemFormModal from 'src/features/allowListItem/components/forms/UpdateAllowListItemFormModal';
import { PERMISSION } from 'src/features/auth/types';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellAllowListItemActions({ row }: CellContext<AllowListItem, unknown>) {
    const { formatMessage } = useIntl();
    const manageAllowLists = useHasPermissions([PERMISSION.MANAGE_ALLOW_LISTS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                {manageAllowLists && (
                    <>
                        <Tooltip>
                            <UpdateAllowListItemFormModal
                                selectedAllowListItem={row.original}
                                semantics={{ entryName: formatMessage(allowListMessages.allowListItem).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateAllowListItemFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteAllowListItemFormModal
                                selectedAllowListItem={row.original}
                                semantics={{ entryName: formatMessage(allowListMessages.allowListItem).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteAllowListItemFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
